var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// /app/SPA/~/core-js/modules/_core.js
// module id = ../../../../core-js/modules/_core.js
// module chunks = 1